const { getTranslationDictionary } = require('core');

function extractCustomsReceipt(text) {
	const translationDictionary = getTranslationDictionary();
	return translationDictionary['customsReceipt'] + text.substring(4);
}

module.exports = extractCustomsReceipt;